<script lang="ts">
  import clsx from 'clsx';

  const { sizeClass = 'w-full h-full' }: { sizeClass?: string } = $props();
</script>

<svg
  viewBox="0 0 33 34"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={clsx(sizeClass, 'overflow-hidden align-middle')}
>
  <path
    d="M12.375 31.1673C13.1344 31.1673 13.75 30.5331 13.75 29.7507C13.75 28.9682 13.1344 28.334 12.375 28.334C11.6156 28.334 11 28.9682 11 29.7507C11 30.5331 11.6156 31.1673 12.375 31.1673Z"
    stroke="black"
    stroke-width="2.66667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M27.5 31.1673C28.2594 31.1673 28.875 30.5331 28.875 29.7507C28.875 28.9682 28.2594 28.334 27.5 28.334C26.7406 28.334 26.125 28.9682 26.125 29.7507C26.125 30.5331 26.7406 31.1673 27.5 31.1673Z"
    stroke="black"
    stroke-width="2.66667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M1.375 1.41602H6.875L10.56 20.3852C10.6857 21.0374 11.0301 21.6233 11.5329 22.0403C12.0356 22.4573 12.6647 22.6788 13.31 22.666H26.675C27.3203 22.6788 27.9494 22.4573 28.4521 22.0403C28.9549 21.6233 29.2993 21.0374 29.425 20.3852L31.625 8.49935H8.25"
    stroke="black"
    stroke-width="2.66667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
